module.exports = {"name":"Zoznam súpisiek","icon":"<i class='material-icons'>list</i>","widget":[{"type":"rosters","schemas":{"rosters-base":"urn:mbry:schema:1:rosters-base:v1","organizations-base":"urn:mbry:schema:1:organizations-base:v1","seasons":"urn:mbry:schema:1:seasons:v1","competitions":"urn:mbry:schema:1:competitions:v1","persons-base":"urn:mbry:schema:1:persons-base:v1"},"limit":30,"initData":{"tags":[]}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/rosters/rosters.json
// module id = 388
// module chunks = 0